/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {LookupService} from './lookup.service';
import {NgEventBus} from 'ng-event-bus';
import { HttpClient } from '@angular/common/http';
import {AppConfigService} from './app-config.service';
import {of, tap} from 'rxjs';
import {UserPreferences} from '../models/user-preferences.model';
import {UserPrefsCategory} from '../models/user-prefs-category.model';
import {UserPrefsGroup} from '../models/user-prefs-group.model';
import {UserPrefsAttrs} from '../models/user-prefs-attrs.model';

@Injectable({
    providedIn: 'root'
})
export class UserPreferencesService {
    title = 'User Preferences Service';
    userPrefsAttrsLookups: UserPrefsAttrs[] = [];
    userPrefsCategoryLookups: UserPrefsCategory[] = [];
    userPrefsGroupLookups: UserPrefsGroup[] = [];
    userPreferencesLoaded: boolean = false;
    userPreferences: UserPreferences = {
        mergeLinesDistanceCalculationMethod: '',
        undockedWindows: []
    };

    constructor(
        private eventBus: NgEventBus,
        private lookupService: LookupService,
        private appConfigService: AppConfigService,
        private http: HttpClient
    ) {}

    loadUserPreferences() {
        if (this.userPreferencesLoaded) {
            return of(null);
        }

        console.info(`${this.title} - loadUserPreferences`);

        this.userPrefsAttrsLookups.splice(
            0,
            this.userPrefsAttrsLookups.length,
            ...this.lookupService.getLookups<UserPrefsAttrs[]>('userPreferencesAttributes')
        );
        this.userPrefsCategoryLookups.splice(
            0,
            this.userPrefsCategoryLookups.length,
            ...this.lookupService.getLookups<UserPrefsCategory[]>('userPreferencesCategorys')
        );
        this.userPrefsGroupLookups.splice(
            0,
            this.userPrefsGroupLookups.length,
            ...this.lookupService.getLookups<UserPrefsGroup[]>('userPreferencesGroups')
        );

        return this.http.get(this.appConfigService.settings.apiGatewayUrl + '/userpreferences/load', {transferCache: false}).pipe(
            tap({
                next: (response: any) => {
                    console.info(`${this.title} - loadUserPreferences success`);
                    if (response && response.undockedWindows && response.mergeLinesDistanceCalculationMethod) {
                        this.userPreferences.undockedWindows = response.undockedWindows;
                        this.userPreferences.mergeLinesDistanceCalculationMethod = response.mergeLinesDistanceCalculationMethod;
                    } else {
                        this.userPreferences.undockedWindows = [];
                        if (this.userPrefsAttrsLookups[0].defaultValue.toLowerCase() === 'true') {
                            this.userPreferences.undockedWindows.push('CONSTRUCTION_TOOLS_WINDOW');
                        }
                        this.userPreferences.mergeLinesDistanceCalculationMethod =
                            parseInt(this.userPrefsAttrsLookups[1].defaultValue) === 1 ? 'SUM_SELECTED_LINES' : 'CALCULATE_FROM_COORDINATES';
                    }
                    this.userPreferencesLoaded = true;
                },
                error: err => {
                    console.error(`${this.title} - loadUserPreferences error:`, err);
                }
            })
        );
    }

    saveUserPreferences(mergeLinesTypeSelected, display) {
        console.info(`${this.title} - saveUserPreferences`);
        const mergeLinesDistanceCalculationMethod = mergeLinesTypeSelected === 1 ? 'SUM_SELECTED_LINES' : 'CALCULATE_FROM_COORDINATES';
        const undockedWindows = [];
        if (display) {
            undockedWindows.push('CONSTRUCTION_TOOLS_WINDOW');
        }
        this.userPreferences.undockedWindows = undockedWindows;
        this.userPreferences.mergeLinesDistanceCalculationMethod = mergeLinesDistanceCalculationMethod;
        const data: any = {};
        data.undockedWindows = undockedWindows;
        data.mergeLinesDistanceCalculationMethod = mergeLinesDistanceCalculationMethod;
        const url = this.appConfigService.settings.apiGatewayUrl + '/userpreferences/save';

        const subs = this.http.post(url, data, {responseType: 'text'}).subscribe({
            next: () => {
                console.info(`${this.title} - saveUserPreferences success`);
            },
            error: error => {
                console.error(`${this.title} - saveUserPreferences error:`, error);
            }
        });
        this.eventBus.cast('nlr:busy', subs);
    }
}
